/**
 * This is a helper for the search page UX improvement features which include:
 * redesign of the search input bar
 * updating the "X" button to clear results, instead of navigating to the homepage
 * retaining search results if user navigates back after clicking on a result
 */

// key to store input for retaining search results
const searchTermStorageKey = 'ab.storage.searchInputUXImprovements';

// only show "X" button when search field has text input
export const showHideCloseButton = (searchInputValueLength, closeButton) => {
    closeButton.style.display = searchInputValueLength > 0 ? 'block' : 'none';
};

// clicking "X" button clears the current text input
export const clearSearchInput = (searchInput) => {
    searchInput.value = '';
    searchInput.focus();

    // remove suggestions subnav
    const suggestionsSubNav = document.getElementById('subnav--search-suggestions');
    if(suggestionsSubNav) {
        suggestionsSubNav.parentNode.removeChild(suggestionsSubNav);
    }
};

// store search term to retain results if user navigates back from detail page
export const storeSearchTerm = (searchInputValue, index) => {
    window.history.pushState(
        {
            searchTerm: searchInputValue,
            showsMoviesIndex: index,
        },
        searchTermStorageKey,
        null,
    );
    window.localStorage.setItem(searchTermStorageKey, encodeURIComponent(searchInputValue));
};

// if user navigates back, set the search input to their previous term
export const setSearchTerm = (searchInput) => {
    const searchTerm = window.history.state?.searchTerm;
    searchInput.value = searchTerm ? searchTerm : '';
};

// if user clicks the search icon after landing on a detail page from search, retain the previous results
export const setSearchIconToPreviousPage = () => {
    const searchTerm = localStorage.getItem(searchTermStorageKey);
    if (searchTerm) {
        const searchIcon = document
            .getElementById('global-header-container')
            .querySelector('.header__wrap .header__nav .navigation li .search');
        searchIcon.addEventListener('click', (event) => {
            event.preventDefault();
            window.history.back();
        });
        // ensure search results are retained only after one page refresh from search
        localStorage.removeItem(searchTermStorageKey);
    }
};

// Manually trigger a click so the user will be anchored on the item they had tapped on
export const anchorToItem = () => {
    const showMovieIndex = window.history.state?.showsMoviesIndex;

    if (showMovieIndex) {
        const el = document.querySelector(
            `#search .search__results .search__results--results #${showMovieIndex}`,
        );
        el.scrollIntoView();
        window.history.pushState({}, searchTermStorageKey, null);
    }
};